import '../global.css';
import { Nav } from './Nav';

export const Root = () => {
  return (
    <>
      <Nav />
    </>
  );
};
